import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=5a1f961d&scoped=true"
import script from "./GameDetail.vue?vue&type=script&lang=js"
export * from "./GameDetail.vue?vue&type=script&lang=js"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=5a1f961d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f961d",
  null
  
)

export default component.exports